document.addEventListener('DOMContentLoaded', function () {
	const urlParams = new URLSearchParams(window.location.search);
	const currentUrl = window.location.href;

	// All your Gravity Form IDs
	const formIds = [26, 27, 28, 29,];

	const utmFieldMap = {
		utm_source: 'input_%formId%_4',
		utm_medium: 'input_%formId%_9',
		utm_campaign: 'input_%formId%_8',
		utm_term: 'input_%formId%_12',
		utm_content: 'input_%formId%_11',
		gclid: 'input_%formId%_6',
		rdt_cid: 'input_%formId%_7',
		full_url: 'input_%formId%_14',
	};

	formIds.forEach(function (formId) {
		// 1️⃣ Set all regular UTM fields
		for (const [param, inputIdPattern] of Object.entries(utmFieldMap)) {
			const selector = `#${inputIdPattern.replace('%formId%', formId)}`;
			const inputs = document.querySelectorAll(selector);

			let value =
				param === 'full_url' ? currentUrl : urlParams.get(param);

			if (value) {
				inputs.forEach((input) => {
					input.value = value;
					console.log(
						`Set ${param} to "${value}" in field #${input.id}`
					);
				});
			}
		}

		// 2️⃣ Determine dynamic phone based on utm_source
		const utmSourceField = document.querySelector(`#input_${formId}_4`);
		const dynamicPhoneField = document.querySelector(`#input_${formId}_17`);

		if (utmSourceField && dynamicPhoneField) {
			let utmSource = utmSourceField.value;

			// If no utm_source in the field, check URL or localStorage fallback
			if (!utmSource) {
				utmSource =
					urlParams.get('utm_source') ||
					localStorage.getItem('utm_source') ||
					'';
			}

			let phoneNumber;
			switch (utmSource) {
				case 'google':
					phoneNumber = '1-833-421-2768';
					break;
				case 'reddit':
					phoneNumber = '1-833-421-2766';
					break;
				case 'cwf':
					phoneNumber = '1-833-421-2769';
					break;
				case 'direct':
					phoneNumber = '1-833-622-7404';
					break;
				default:
					phoneNumber = '1-833-421-2763'; // fallback
			}

			dynamicPhoneField.value = phoneNumber;

			console.log(
				`Set dynamic phone to "${phoneNumber}" based on utm_source "${utmSource}" in form ${formId}`
			);
		}
	});
});
